import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'polylearn-lerobert-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeRobertFooterComponent implements OnInit {
  logos = [
    {
      src: 'qualiopi@2x.png'
    },
    {
      src: 'datadock@2x.png'
    },
    {
      src: 'deontologie-cpf@2x.png'
    },
    {
      src: 'eligible-au-cpf@2x.png'
    }
  ];

  constructor() {}

  ngOnInit(): void {}
}
